import request from '@/utils/request';
export function csmessageInitCs(data) {
  return request({
    url: 'cs-message/conversation/initCs',
    method: 'post',
    params: data
  });
}
export function myConversations(data) {
  return request({
    url: 'cs-message/my-conversations',
    method: 'get',
    params: data
  });
}
export function csmessageMessage(data) {
  return request({
    url: 'cs-message',
    method: 'post',
    params: data
  });
}
export function msgList(data) {
  return request({
    url: 'cs-message/conversation/msgList',
    method: 'get',
    params: data
  });
}
export function csmessageClose(data) {
  return request({
    url: 'cs-message/close',
    method: 'post',
    params: data
  });
}
export function csDisconnect(data) {
  return request({
    url: 'cs-disconnect',
    method: 'post',
    params: data
  });
}
export function csUpload(data) {
  return request({
    url: 'cs-upload',
    method: 'post',
    params: data
  });
}
export function csRead(data) {
  return request({
    url: 'cs-read',
    method: 'post',
    params: data
  });
}
export function customConfig(data) {
  return request({
    url: 'custom-config',
    method: 'get',
    params: data
  });
}
export function unreadStatus(data) {
  return request({
    url: 'cs-message/unread-status',
    method: 'get',
    params: data
  });
}
export function saveAutoReplyMsg(data) {
  return request({
    url: 'cs-message/save-auto-reply-msg',
    method: 'post',
    params: data
  });
}
export function bindLeaveByCustomer(data) {
  return request({
    url: 'cs-message/bind-leave-by-customer',
    method: 'post',
    params: data
  });
}
export function adminList(data) {
  return request({
    url: 'cs-message/admin-list',
    method: 'get',
    params: data
  });
}
export function customerMsgList(data) {
  return request({
    url: 'cs-message/customer-msg-list',
    method: 'get',
    params: data
  });
}
export function getDocTypes(data) {
  return request({
    url: 'ai-cs-config/get-doc-types',
    method: 'get',
    params: data
  });
}
export function createDocType(data) {
  return request({
    url: 'ai-cs-config/create-doc-type',
    method: 'post',
    params: data
  });
}
export function updateDocType(data) {
  return request({
    url: 'ai-cs-config/update-doc-type',
    method: 'post',
    params: data
  });
}
export function createImportJob(data) {
  return request({
    url: 'ai-cs-config/create-import-job',
    method: 'post',
    params: data
  });
}
export function importJobs(data) {
  return request({
    url: 'ai-cs-config/import-jobs',
    method: 'get',
    params: data
  });
}
export function detailImportJob(data) {
  return request({
    url: 'ai-cs-config/detail-import-job',
    method: 'get',
    params: data
  });
}
export function getDocumentsVersion(data) {
  return request({
    url: 'ai-cs-config/get-documents-version',
    method: 'get',
    params: data
  });
}
export function updateDocumentVersion(data) {
  return request({
    url: 'ai-cs-config/update-document-version',
    method: 'post',
    params: data
  });
}
export function publishDocument(data) {
  return request({
    url: 'ai-cs-config/publish-document',
    method: 'post',
    params: data
  });
}
export function disableDocument(data) {
  return request({
    url: 'ai-cs-config/disable-document',
    method: 'post',
    params: data
  });
}
export function reindexDocument(data) {
  return request({
    url: 'ai-cs-config/reindex-document',
    method: 'post',
    params: data
  });
}
export function retrieveTest(data) {
  return request({
    url: 'ai-cs-config/retrieve-test',
    method: 'post',
    params: data
  });
}
export function delAutoReplyMsg(data) {
  return request({
    url: 'cs-message/del-auto-reply-msg',
    method: 'post',
    params: data
  });
}
export function keywordReplyList(data) {
  return request({
    url: 'cs-message/keyword-reply/list',
    method: 'get',
    params: data
  });
}
export function keywordReplyCreate(data) {
  return request({
    url: 'cs-message/keyword-reply/create',
    method: 'post',
    params: data
  });
}
export function keywordReplyUpdate(data) {
  return request({
    url: 'cs-message/keyword-reply/update',
    method: 'post',
    params: data
  });
}
export function keywordReplyDelete(data) {
  return request({
    url: 'cs-message/keyword-reply/delete',
    method: 'post',
    params: data
  });
}
export function heartbeat(data) {
  return request({
    url: 'cs-message/heartbeat',
    method: 'post',
    params: data
  });
}
export function onlineKf(data) {
  return request({
    url: 'cs-message/online-kf',
    method: 'get',
    params: data
  });
}